<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-praying-hands</v-icon>
        <h1 class="title ml-2">Pedidos de oracion</h1>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="oraciones"
          :headers="headers"
          hide-default-footer
          :items-per-page="25"
        >
          <template v-slot:item.mensaje="{ item }">
            {{ item.mensaje.substring(0, 100) + '...' }}
          </template>
          <template v-slot:item.aprobado="{ item }">
            <v-icon v-if="item.aprobado" color="success">fas fa-check</v-icon>
            <v-icon v-else color="error">fas fa-times</v-icon>
          </template>
          <template v-slot:item.publico="{ item }">
            <v-icon v-if="item.publico" color="success">fas fa-check</v-icon>
            <v-icon v-else color="error">fas fa-times</v-icon>
          </template>
          <template v-slot:item.opciones="{ item }">
            <v-btn small tile color="primary" icon @click="showItem(item.id)">
              <v-icon>fas fa-list</v-icon>
            </v-btn>
            <v-btn small tile color="secondary" icon @click="editItem(item.id)" class="ml-2">
              <v-icon>fas fa-edit</v-icon>
            </v-btn>
            <v-btn small tile color="error" icon @click="deleteItem(item.id)" class="ml-2">
              <v-icon>fas fa-trash</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="pages"
        ></v-pagination>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showEdit" max-width="650px">
      <EditOracion
        v-model="selected"
        :id="idSelected"
        @close="showEdit = false"
        @saved="refresh()"
      ></EditOracion>
    </v-dialog>
    <v-dialog v-model="showOracion" max-width="650px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon>fas fa-praying-hands</v-icon>
          <span class="ml-2">Pedido de oración</span>
        </v-card-title>
        <v-card-text>
          <p class="mt-4"><strong>Nombre: </strong>{{ selected.nombre }}</p>
          <p><strong>Teléfono: </strong>{{ selected.telefono }}</p>
          <p><strong>E-mail: </strong>{{ selected.email }}</p>
          <p><strong>Fecha: </strong>{{ selected.fecha }}</p>
          <p class="font-weight-bold">Mensaje:</p>
          <p>{{selected.mensaje}}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="showOracion = false">
            <v-icon left>fas fa-times</v-icon>
            Cerrar
          </v-btn>
          <v-btn v-if="!selected.aprobado" color="primary" @click="aprobar(idSelected)">
            <v-icon left>fas fa-check</v-icon>
            Aprobar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EditOracion from '../components/EditOracion'
import dayjs from 'dayjs'
export default {
  data () {
    return {
      oraciones: [],
      headers: [
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Teléfono', value: 'telefono', sortable: true },
        { text: 'E-mail', value: 'email', sortable: true },
        { text: 'Mensaje', value: 'mensaje', sortable: false, width: '200px' },
        { text: 'Aprobado', value: 'aprobado', sortable: false },
        { text: 'Publico', value: 'publico', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false }
      ],
      page: 1,
      pages: 1,
      selected: {
        nombre: '',
        telefono: '',
        email: '',
        mensaje: '',
        publico: false,
        aprobado: false
      },
      idSelected: null,
      showEdit: false,
      showOracion: false
    }
  },
  components: {
    EditOracion
  },
  async created () {
    await this.getPages()
    await this.getOraciones()
  },
  methods: {
    async aprobar (id) {
      await this.$http.oraciones.put(`/${id}`, { aprobado: true })
      this.showOracion = false
      this.getOraciones()
    },
    async getPages () {
      const { data } = await this.$http.oraciones.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getOraciones () {
      const skip = (this.page - 1) * 25
      const { data } = await this.$http.oraciones.get(`?_sort=createdAt:ASC&_limit=25&_start=${skip}`)
      this.oraciones = data.map(i => {
        return {
          ...i,
          fecha: dayjs(i.createdAt).format('DD-MM-YYYY')
        }
      })
    },
    showItem (id) {
      const oracion = this.oraciones.find(i => i.id === id)
      this.selected = {
        nombre: oracion.nombre,
        telefono: oracion.telefono,
        email: oracion.email,
        mensaje: oracion.mensaje,
        aprobado: oracion.aprobado,
        fecha: oracion.fecha,
        publico: oracion.publico
      }
      this.idSelected = oracion.id
      this.showOracion = true
    },
    editItem (id) {
      const oracion = this.oraciones.find(i => i.id === id)
      this.selected = {
        nombre: oracion.nombre,
        telefono: oracion.telefono,
        email: oracion.email,
        mensaje: oracion.mensaje,
        aprobado: oracion.aprobado,
        publico: oracion.publico
      }
      this.idSelected = oracion.id
      this.showEdit = true
    },
    async deleteItem (id) {
      if (window.confirm('¿Estas seguro de eliminar el registro?')) {
        await this.$http.oraciones.delete(`/${id}`)
        this.getPages()
        this.getOraciones()
      }
    },
    refresh () {
      this.showEdit = false
      this.getOraciones()
    }
  },
  watch: {
    page () {
      this.getOraciones()
    }
  }
}
</script>
